module.exports = {
      id: "share-x-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#share-x",
      toString: function () {
        return this.url;
      }
    }